import React from "react";
import moment from "moment";
import "moment/locale/pt-br";
import { fmtBRL } from "constants/assinaturaTheme";

/**
 * Composição do VALOR do checkout de flip/troca — o número seco ("R$ 44,33")
 * não se explica sozinho. Mostra a conta por trás, por caso:
 *  - flip MENSAL (mesmo ciclo): diferença de mensalidade × proporcional aos
 *    dias que restam do ciclo já pago;
 *  - troca pro ANUAL (cross-ciclo): valor cheio do anual − crédito do período
 *    já pago e não usado do plano atual;
 *  - PREPAGA (fronteira da fase): valor cheio do plano novo, começa na virada.
 * Os números exibidos derivam dos MESMOS campos que o back usou pra calcular
 * (snapshot atual, fixo do destino, valor a pagar) — display, não recomputa.
 */
const linha = (rotulo, valor, forte) => (
	<div
		style={{
			display: "flex",
			justifyContent: "space-between",
			gap: 12,
			fontWeight: forte ? 700 : 400,
			marginTop: forte ? 6 : 2,
			paddingTop: forte ? 6 : 0,
			borderTop: forte ? "1px dashed #e8e8e8" : "none",
		}}
	>
		<span>{rotulo}</span>
		<span>{valor}</span>
	</div>
);

const ComposicaoValorFlip = ({
	prepaga = false,
	crossCiclo = false,
	fixoAtual = 0,
	fixoNovo = 0,
	valorAPagar = 0,
	pagoAte = null,
}) => {
	const fimCiclo = pagoAte ? moment(pagoAte).format("DD/MM/YYYY") : null;

	let conteudo;
	if (prepaga) {
		conteudo = (
			<>
				{linha(`Plano novo (valor cheio)`, fmtBRL(fixoNovo))}
				{linha("Você paga agora", fmtBRL(valorAPagar), true)}
				<div style={{ marginTop: 6, color: "rgba(0,0,0,.45)" }}>
					O plano novo começa no fim do período atual
					{fimCiclo ? ` (${fimCiclo})` : ""}; até lá nada muda.
				</div>
			</>
		);
	} else if (crossCiclo) {
		const abatimento = Math.max(0, fixoNovo - valorAPagar);
		conteudo = (
			<>
				{linha("Plano anual (valor cheio)", fmtBRL(fixoNovo))}
				{abatimento > 0 &&
					linha(
						`− Crédito do período já pago no plano atual${
							fimCiclo ? ` (até ${fimCiclo})` : ""
						}`,
						`− ${fmtBRL(abatimento)}`,
					)}
				{linha("Você paga agora", fmtBRL(valorAPagar), true)}
				<div style={{ marginTop: 6, color: "rgba(0,0,0,.45)" }}>
					Seu novo ciclo anual começa hoje.
				</div>
			</>
		);
	} else {
		const diferencaMes = Math.max(0, fixoNovo - fixoAtual);
		conteudo = (
			<>
				{linha("Plano novo", `${fmtBRL(fixoNovo)}/mês`)}
				{linha("Plano atual", `${fmtBRL(fixoAtual)}/mês`)}
				{linha("Diferença", `${fmtBRL(diferencaMes)}/mês`)}
				{linha(
					`Proporcional aos dias que restam do ciclo já pago${
						fimCiclo ? ` (até ${fimCiclo})` : ""
					}`,
					fmtBRL(valorAPagar),
					true,
				)}
				<div style={{ marginTop: 6, color: "rgba(0,0,0,.45)" }}>
					Na renovação{fimCiclo ? ` (${fimCiclo})` : ""}, passa a
					valer o valor cheio do plano novo.
				</div>
			</>
		);
	}

	return (
		<div
			style={{
				background: "#fafafa",
				border: "1px solid #f0f0f0",
				borderRadius: 10,
				padding: "10px 14px",
				marginBottom: 16,
				fontSize: 13,
				color: "rgba(0,0,0,.65)",
			}}
		>
			<div
				style={{
					fontSize: 11,
					fontWeight: 700,
					textTransform: "uppercase",
					letterSpacing: ".05em",
					color: "rgba(0,0,0,.45)",
					marginBottom: 6,
				}}
			>
				Como chegamos neste valor
			</div>
			{conteudo}
		</div>
	);
};

export default ComposicaoValorFlip;
